"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableError = void 0;
/**
 * TableError.ts
 *
 * Table error which can be thrown with a code specifying the type of
 * error, as well as an HTTP status code.  Useful for throwing errors from
 * server API or backend, through to the frontend for display and handling.
 */
const TableErrorType_1 = require("../enums/TableErrorType");
class TableError {
    constructor(message, errorType = TableErrorType_1.TableErrorType.INTERNAL_ERROR, statusCode = 500) {
        this.message = message;
        this.errorType = errorType;
        this.statusCode = statusCode;
    }
}
exports.TableError = TableError;
//# sourceMappingURL=TableError.js.map